import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GeneralConstants } from '../constants/general.constants';
import { StorageConstants } from '../constants/storage.constants';
import { GameService } from './game.service';


@Injectable({
  providedIn: 'root',
})
export class NameService {
  private nameChangeSource: Subject<string> = new Subject<string>();
  nameChangeReceived$: Observable<string> = this.nameChangeSource.asObservable();

  constructor(private gameService: GameService, private http: HttpClient) { }

  validateName(newName: string): boolean {
    let trimmedName: string = newName.trim();
    return !(trimmedName == "" || trimmedName == null || trimmedName.length > 16);
  }

  getNameErrors(name: string): string {
    let trimmedName: string = name.trim();
    if (trimmedName == "" || trimmedName == null) {
      return "U heeft geen naam ingevoerd";
    }

    if (trimmedName.length > GeneralConstants.GameNameMaxLength) {
      return "Een naam mag maximaal " + GeneralConstants.GameNameMaxLength + " tekens bevatten";
    }

    return "Geen fout gevonden";
  }

  async saveName(newName: string) {
    let trimmedName: string = newName.trim();
    if (this.validateName(trimmedName)) {
      if (this.gameService.isConnected()) {
        await this.changeName(trimmedName);
        localStorage.setItem(StorageConstants.PlayerName, trimmedName);
        this.nameChangeSource.next(trimmedName);
      }
      else {
        localStorage.setItem(StorageConstants.PlayerName, trimmedName);
        this.nameChangeSource.next(trimmedName);
      }
    }
  }

  getInitials(name: string): string {
    if (name == null) {
      return "";
    }

    let trimmedName: string = name.trim();
    if (trimmedName != null && trimmedName != "") {
      let parts: Array<string> = trimmedName.split(" ");
      if (parts.length > 0) {
        let initials: string = "";

        parts.forEach((part: string) => {
          initials = initials.concat(part.charAt(0));
        });

        return initials;
      }
    }
    return "";
  }

  private changeName(newName: string) {
    let trimmedName: string = newName.trim();
    let gameID = sessionStorage.getItem(StorageConstants.GameID);
    let playerID = sessionStorage.getItem(StorageConstants.PlayerID);
    return this.http.post<string>(this.gameService.restUrl + gameID + '/changeName/' + playerID, { playerName: trimmedName }).toPromise();
  }
}

